export default "__VITE_ASSET__7cc5f09e__"